// WP-A · shared field components — label + input + inline error. Keeps the four
// forms consistent and small. Inputs call back with {field, value}.
export function TextField({ label, field, value, onInput, error, type = "text", placeholder, required, readOnly }) {  return (
    <label class="field">
      <span class="field-label">
        {label}
        {required ? <span class="req">*</span> : null}
      </span>
      <input
        type={type}
        value={value ?? ""}
        placeholder={placeholder}
        onInput={onInput ? (e) => onInput(field, e.currentTarget.value) : undefined}
        readOnly={readOnly}
        aria-invalid={!!error}
      />
      {error ? <span class="field-error">{error}</span> : null}
    </label>
  );
}

export function SelectField({ label, field, value, onChange, error, options, required, placeholder, disabled, readOnly }) {
  return (
    <label class="field">
      <span class="field-label">
        {label}
        {required ? <span class="req">*</span> : null}
      </span>
      <select
        value={value ?? ""}
        onChange={disabled || readOnly ? undefined : (e) => onChange(field, e.currentTarget.value)}
        disabled={disabled}
        aria-invalid={!!error}
      >
        {placeholder ? <option value="">{placeholder}</option> : null}
        {options.map((o) => (
          <option value={o.value ?? o}>{o.label ?? o}</option>
        ))}
      </select>
      {error ? <span class="field-error">{error}</span> : null}
    </label>
  );
}

/**
 * Submit-time clarity (session 34): after a failed submit, one banner above
 * the button lists EXACTLY what's missing in plain words — the per-field red
 * errors still point at the spot, but a guest on a phone should never have to
 * hunt for why "it won't submit". `labels` maps error keys to friendly
 * phrases; unknown keys surface verbatim (never invisible).
 * Render it right above the submit button: `<MissingBanner errors={errors} labels={...} />`.
 */
export function MissingBanner({ errors, labels }) {
  const keys = Object.keys(errors || {}).filter((k) => errors[k]);
  if (!keys.length) return null;
  const items = keys.map((k) => labels[k] || String(k));
  return (
    <div class="missing-banner" role="alert">
      <p><strong>Still missing:</strong> {items.join(" · ")}</p>
    </div>
  );
}
